import {archivedFetch as fetch} from '@/utils/fetch';

export function addAndUpdateVoteTwoRecruitInit(args) {
    let params = new URLSearchParams();
    params.append('maxBirthday', args.maxBirthday);
    params.append('maxRecruitCount', args.maxRecruitCount);
    params.append('minBirthday', args.minBirthday);

    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'structure/voteTwo/addAndUpdateVoteTwoRecruitInit',
        method: 'post',
        data: JSON.stringify(args)
    });
}

// 根据学校Id查询初始化设置
export function getVoteTwoRecruitInit() {

    return fetch({
        url: 'structure/voteTwo/getVoteTwoRecruitInit',
        method: 'post'
    });
}

// 新增问卷
export function addVoteTwo(args, schoolYear) {
    const params = new URLSearchParams();
    if(schoolYear) {
        params.append('schoolYear', schoolYear);
    }
    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        params,
        url: 'structure/voteTwo/addVoteTwo',
        method: 'post',
        data: JSON.stringify(args)
    });
}

// 查询招生报名问卷模板
export function getVoteTwoTempList(args) {
    const params = new URLSearchParams();
    params.append('voteTitle', args.voteTitle);

    return fetch({
        url: 'structure/voteTwo/getVoteTwoTempList',
        method: 'post',
        data: params
    });
}

// 根据问卷Id查询
export function getVoteTwoById(args) {
    const params = new URLSearchParams();
    params.append('voteId', args.voteId);

    return fetch({
        url: 'structure/voteTwo/getVoteTwoById',
        method: 'get',
        params
    });
}

// 修改问卷
export function updateVoteTwo(args) {
    const params = new URLSearchParams();
    params.append('anonymous', args.anonymous);
    params.append('expriyDate', args.expriyDate);
    params.append('id', args.id);
    params.append('isShowResult', args.isShowResult);
    params.append('sendUserType', args.sendUserType);
    params.append('stuDepartJson', args.stuDepartJson);
    params.append('thScopeJson', args.thScopeJson);
    params.append('topicList', args.topicList);
    params.append('voteDesc', args.voteDesc);
    params.append('voteStatus', args.voteStatus);
    params.append('voteTitle', args.voteTitle);

    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'structure/voteTwo/updateVoteTwo',
        method: 'post',
        data: JSON.stringify(args)
    });
}

// 根据问卷id删除问卷
export function delVoteTwoById(args) {
    const params = new URLSearchParams();
    params.append('voteId', args.voteId);
    return fetch({
        url: 'structure/voteTwo/delVoteTwoById',
        method: 'post',
        data: params
    });
}

// 问卷预览
export function sendViewVoteTwo(args, schoolYear) {
    const params = new URLSearchParams();
    if(schoolYear) {
        params.append('schoolYear', schoolYear);
    }
    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        params,
        url: 'structure/voteTwo/sendViewVoteTwo',
        method: 'post',
        data: JSON.stringify(args)
    });
}




// WEBPACK FOOTER //
// ./src/api/setting.js